<template>
  <div class="dashboard-container">
    <!-- En-tête -->
    <h2 class="dashboard-title">☕ Tableau de bord</h2>
    <p class="dashboard-subtitle">Vue d’ensemble rapide de ton activité café</p>

    <!-- 📊 Résumé -->
    <div class="summary-grid">
      <div class="summary-card">
        <span class="icon">☕</span>
        <div>
          <p class="value">{{ report.total_coffee }} kg</p>
          <p class="label">Café acheté</p>
        </div>
      </div>

      <div class="summary-card">
        <span class="icon">💵</span>
        <div>
          <p class="value">{{ report.total_income }} MAD</p>
          <p class="label">Recettes</p>
        </div>
      </div>

      <div class="summary-card">
        <span class="icon">💸</span>
        <div>
          <p class="value">{{ report.total_expenses }} MAD</p>
          <p class="label">Charges</p>
        </div>
      </div>

      <div class="summary-card net-profit">
        <span class="icon">📈</span>
        <div>
          <p class="value">{{ report.net_profit }} MAD</p>
          <p class="label">Bénéfice net</p>
        </div>
      </div>
    </div>

    <!-- 🧭 Boutons de navigation -->
    <h4 class="section-title">Navigation rapide</h4>
    <div class="nav-buttons">
      <button
        v-for="card in cards"
        :key="card.label"
        class="nav-btn"
        :style="{ backgroundColor: card.color }"
        @click="goTo(card.path)"
      >
        <div class="btn-icon">{{ card.icon }}</div>
        <div class="btn-label">{{ card.label }}</div>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Dashboard",
  computed: {
    ...mapGetters("report", ["getReport"]),
    report() {
      return this.getReport;
    },
  },
  data() {
    return {
      cards: [
        { label: "Rapport mensuel", icon: "📊", path: "/monthly-report", color: "#4e73df" },
        { label: "Stock de café", icon: "☕", path: "/coffee-stock", color: "#1cc88a" },
        { label: "Recettes", icon: "💰", path: "/cash-income", color: "#36b9cc" },
        { label: "Charges", icon: "💸", path: "/expenses", color: "#f6c23e" },
      ],
    };
  },
  methods: {
    ...mapActions("report", ["fetchReport"]),
    goTo(path) {
      this.$router.push(path);
    },
  },
  created() {
    this.fetchReport();
  },
};
</script>

<style scoped>
/* 🌤 Conteneur principal */
.dashboard-container {
  background: #f8fafc;
  min-height: 100vh;
  padding: 20px 15px 60px;
  color: #333;
  font-family: "Poppins", Avenir, Helvetica, sans-serif;
}

/* 🏷 Titres */
.dashboard-title {
  font-size: 22px;
  font-weight: 700;
  color: #2b2b2b;
  margin-bottom: 4px;
  text-align: center;
}

.dashboard-subtitle {
  font-size: 14px;
  color: #6c757d;
  text-align: center;
  margin-bottom: 25px;
}

/* 📊 Cartes de résumé */
.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 14px;
}

.summary-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 14px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}
.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
}
.summary-card .icon {
  font-size: 26px;
}
.summary-card .value {
  font-weight: 700;
  font-size: 16px;
  color: #2b2b2b;
  margin: 0;
}
.summary-card .label {
  font-size: 13px;
  color: #888;
  margin: 0;
}
.summary-card.net-profit {
  background: linear-gradient(135deg, #d9f8e5, #b4f0cb);
}

/* 🧭 Boutons de navigation */
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #4c4c4c;
  margin: 25px 0 12px;
  text-align: center;
}

.nav-buttons {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.nav-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: none;
  color: white;
  border-radius: 18px;
  padding: 25px 10px;
  font-weight: 600;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.nav-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.2);
}
.btn-icon {
  font-size: 26px;
  margin-bottom: 6px;
}
.btn-label {
  font-size: 14px;
}

/* 🌈 Dégradés pour les boutons */
.nav-btn:nth-child(1) {
  background: linear-gradient(135deg, #4e73df, #2e59d9);
}
.nav-btn:nth-child(2) {
  background: linear-gradient(135deg, #1cc88a, #17a673);
}
.nav-btn:nth-child(3) {
  background: linear-gradient(135deg, #36b9cc, #258faf);
}
.nav-btn:nth-child(4) {
  background: linear-gradient(135deg, #f6c23e, #dda20a);
}
</style>
